module.exports = __webpack_public_path__ + "img/train-4.6bb3048f.jpg";